module.exports = __webpack_public_path__ + "img/20210812.8fca6144.gif";